import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AggregatorService } from './api/aggregator.service';
import { ApiKeyService } from './api/apiKey.service';
import { CustomerSupportService } from './api/customerSupport.service';
import { DataTrackerService } from './api/dataTracker.service';
import { EnergyPriceService } from './api/energyPrice.service';
import { EnergyProviderService } from './api/energyProvider.service';
import { HealthService } from './api/health.service';
import { MeteringDataService } from './api/meteringData.service';
import { MeteringPointService } from './api/meteringPoint.service';
import { PermissionService } from './api/permission.service';
import { PersonService } from './api/person.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
